import Vue from "vue";
import Vuex from "vuex";
import user from "./module/user";
import language from "./module/language";
import currency from "./module/currency";
import constant from "./module/constant/index";
import applyment from "./module/applyment";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    language,
    currency,
    constant,
    applyment,
  },
});
